(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/draws.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/draws.js'); 
'use strict';

const _excluded = ["productItsIds"],
  _excluded2 = ["dateToday"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const {
  isSameProduct,
  getProductId,
  getProductItsId,
  getProductNumeric,
  getJokerProductNumeric
} = svs.numbergames.productMapping;
const findDraw = (_ref, productId) => {
  let {
    currentDraws,
    futureDraws,
    jokerDraws
  } = _ref;
  let jokerDraw;
  if (jokerDraws) {
    const jokerNumericId = getJokerProductNumeric(productId);
    jokerDraw = jokerDraws.find(_ref2 => {
      let {
        futureDraws = []
      } = _ref2;
      return futureDraws[0].productId === jokerNumericId;
    });
  }
  const numericId = getProductNumeric(productId);
  return {
    currentDraw: currentDraws.find(draw => draw.productId === numericId),
    futureDraws: futureDraws.find(draw => draw.productId === numericId),
    jokerDraw
  };
};
class Draws {
  constructor(_ref3) {
    let {
        productItsIds
      } = _ref3,
      drawData = _objectWithoutProperties(_ref3, _excluded);
    this.productItsIds = productItsIds;
    this.draws = drawData;
    this.upcomingDrawProduct = drawData.currentDraws;
  }
  set draws(_ref4) {
    let {
        dateToday
      } = _ref4,
      drawData = _objectWithoutProperties(_ref4, _excluded2);
    this.productItsIds.forEach(id => {
      this[id] = new svs.numbergames.draws.Draw(_objectSpread(_objectSpread({}, findDraw(_objectSpread({}, drawData), id)), {}, {
        dateToday
      }));
    });
  }
  get product() {
    return getProductId(this.productItsIds[0]);
  }
  get isOpen() {
    return this.productItsIds.some(productItsId => this[productItsId].isOpen);
  }
  isProductOpen(product) {
    var _this$getProductItsId;
    return (_this$getProductItsId = this[getProductItsId(product)]) === null || _this$getProductItsId === void 0 ? void 0 : _this$getProductItsId.isOpen;
  }
  get isJokerOpen() {
    return this.productItsIds.some(productItsId => this[productItsId].isJokerOpen);
  }
  get upcomingDrawProduct() {
    return this._upcomingDrawProduct;
  }
  set upcomingDrawProduct(currentDraws) {
    var _currentDraws$;
    this._upcomingDrawProduct = svs.numbergames.productMapping.getProductItsId((_currentDraws$ = currentDraws[0]) === null || _currentDraws$ === void 0 ? void 0 : _currentDraws$.productId);
  }
  get wasOpenedToday() {
    return this.productItsIds.find(productItsId => this[productItsId].wasOpenedToday) || false;
  }
  firstAndLastDrawDates(_ref5) {
    var _this$productItsId$fi, _this$productItsId;
    let {
      drawCount,
      productItsId
    } = _ref5;
    return (_this$productItsId$fi = (_this$productItsId = this[productItsId]) === null || _this$productItsId === void 0 ? void 0 : _this$productItsId.firstAndLastDrawDates({
      drawCount
    })) !== null && _this$productItsId$fi !== void 0 ? _this$productItsId$fi : {};
  }
  drawDay(_ref6) {
    let {
      drawCount,
      productItsId
    } = _ref6;
    return _objectSpread({
      productItsId,
      isOpen: this[productItsId].isOpen
    }, this.firstAndLastDrawDates({
      drawCount,
      productItsId
    }));
  }
  drawDays(drawCount) {
    return this.productItsIds.map(productItsId => this.drawDay({
      productItsId,
      drawCount
    }));
  }
  drawNumbers(productItsIds) {
    return productItsIds.map(productItsId => ({
      productItsId,
      drawNumber: this[productItsId].drawNumber
    }));
  }
  firstRegCloseProductOf(products) {
    return products.find(product => isSameProduct(product, this.upcomingDrawProduct));
  }
}
svs.numbergames.draws.Draws = Draws;
 })(window);